export var SceneType = /*#__PURE__*/function (SceneType) {
  SceneType["Video"] = "Video";
  SceneType["Slides"] = "Slides";
  SceneType["Static"] = "Static";
  return SceneType;
}(SceneType || {});
export const SceneTypeOptions = [{
  label: 'Video',
  value: SceneType.Video
}, {
  label: 'Slides',
  value: SceneType.Slides
}, {
  label: 'Statisch',
  value: SceneType.Static
}];